import { test } from './executions/test';

export const executions = ($http: HttpApi) => ({
  create: (params: HttpParams['body']) => $http.$post('/workflow_executions', { body: params }),

  // nested resources
  test: test($http),
});
